import { useParams } from "react-router-dom";

export const useReportId = (): { reportId: number } => {
  const { id: reportIdRaw } = useParams();
  const reportId = reportIdRaw && Number(reportIdRaw) ? Number(reportIdRaw) : 0;
  return { reportId };
};
